const Role = {
  GUEST: 'GUEST',
  PROP_ADMIN: 'PROP_ADMIN',
  PROP_SOLICITOR: 'PROP_SOLICITOR',
  EXTERNAL_SOLICITOR: 'EXTERNAL_SOLICITOR',
  SIGNATORY: 'SIGNATORY'
};

export default Role;